<template>
<div class="wl-n-metarial-wrapper">
    <div class="new-center-content clearfix">
        <div class="new-center-top fl">
            <div class="new-top-nav" :style="{background:'url('+imgs+')'}">
                <h1 class="new-top-title fl">S</h1>
                <div class="fl" style="padding-left:4px;">
                    <p class="new-top-navtitle">学习中心</p>
                    <p class="new-top-ews">TUDY</p>
                </div>
            </div>
            <div class="new-center-tab">
                <div class="new-center-dynamic class-back">
                    教材中心
                    <span class="wl-icon wl-icon-xiangyou fr"></span>
                </div>
                <div class="new-center-dynamic" @click="toVideoList('all')">
                    串讲视频
                    <span class="wl-icon wl-icon-xiangyou fr"></span>
                </div>
                <div class="new-center-dynamic c-video-change-btn" v-for="(item,index) in videoTypeList" :key="index" @click="toVideoList(item.value)">
                    {{item.label}}
                    <span class="wl-icon wl-icon-xiangyou fr"></span>
                </div>
                <a class="link-child-li" href="http://ykt.clppx.org.cn/wlykt/home" target="_blank">
                    <div class="new-center-dynamic">
                        中物联云课堂
                        <span class="wl-icon wl-icon-xiangyou fr"></span>
                    </div>
                </a>
                <a class="link-child-li" href="http://test.clppx.org.cn/login" target="_blank">
                    <div class="new-center-dynamic">
                        模拟练习平台
                        <span class="wl-icon wl-icon-xiangyou fr"></span>
                    </div>
                </a>
            </div>
        </div>
        <div class="fr left-main-content">
            <div class="new-center-listnav">
                <h2>教材中心</h2>
                <div class="new-center-path">
                    <div class="crumbs-text">
                        <i class="wl-icon-zhuye1"></i>
                        <span>当前位置：</span>
                        <span @click="goHome" style="cursor: pointer;">网站首页</span>
                        <span>></span>
                        <span>串讲视频</span>
                    </div>
                </div>
            </div>
            <div class="metarial-list-con">
                <div class="choose-publishBooks-time clearfix">
                    <span class="fl change-year-btn change-label">出版时间：</span>
                    <span class="fl change-year-btn" @click="getFullYear" :class="{'yearActive' : yearShowActive == true}">全部</span>
                    <span v-for="(item,index) in timeList" :key="index" class="fl change-year-btn" @click="getYear(index,item)" :class="{'yearActive' : yearIndexShowActive == index}">{{item}}年</span>
                    <span class="fl change-year-btn" @click="getEndYear" :class="{'yearActive' : endYearShowActive == true}">{{endYear}}年以前</span>
                </div>
                <div class="choose-publishBooks-time certificate-type-change-con clearfix">
                    <span class="fl change-year-btn change-label">证书类型：</span>
                    <span v-for="item in certifycateList" :key="item.id" :class="{'yearActive':certifycateId == item.id}" class="fl change-year-btn" @click="changeCerfityType(item.id)">{{item.CertificateName}}</span>
                </div>
            </div>
            <div class="meta-list-main">
                <ul class="metarial-list-ul-con clearfix">
                    <li v-for="(item,index) in booksInfoList" :key="index" class="fl clearfix metarial-list-li">
                        <router-link :to="{name:'teachingDetails',params:{bookId:item.Id}}" target="_blank">
                            <div class="publishBooks-list-img fl">
                                <img :src="item.BookCover" style="width: 100%" />
                            </div>
                            <div class="publishBooks-list-info fr">
                                <h3 class="info-books-name">{{item.Title}}</h3>
                                <p class="info-books-author">
                                    <span style="margin-right: 7px;">作者：</span>
                                    <span>{{item.Author}}</span>
                                    <span style="margin-left: 35px;margin-right: 7px;">出版时间：</span>
                                    <span>{{item.IssueDate}}</span>
                                </p>
                                <p class="info-books-author">
                                    <span style="margin-right:">ISBN：</span>
                                    <span>{{item.ISBN}}</span>
                                </p>
                                <p class="info-books-author">图书简介：</p>
                                <p class="info-books-introduce">{{item.TextBookBrief}}</p>
                            </div>
                        </router-link>
                    </li>
                </ul>
                <div class="el-block-pagination" v-if="booksInfoList.length > 0">
                    <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage4" :page-sizes="[10, 20, 40, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="totalCount"></el-pagination>
                </div>
                <div class="no-data-tip-con" v-else>
                    <img src="~assets/images/the-last-new-nodata-imag.png" alt class="yk-prompt">
                </div>
            </div>
        </div>
    </div>
    <div class="ph-new-center-content">
        <div class="crumbs-text">
            <div style="padding:0 20px;">
                <i class="wl-icon-zhuye1"></i>
                <span @click="goHome" style="cursor: pointer;">首页</span>
                <span>></span>
                <span>教材中心</span>
            </div>
        </div>
        <div class="new-center-navigation clearfix">
            <h2 class="activa">教材中心</h2>
            <h2 @click="toVideoList('all')">串讲视频</h2>
        </div>
        <div>
            <div class="clearfix ph-select-year-btn" @click="showPhoneYear = true">出版时间：{{phoneSelectYear}} <span v-if="phoneSelectYear != '全部'">年</span> <i class="el-icon-caret-bottom"></i></div>
            <div class="clearfix ph-select-year-btn" @click="showPhoneCerfity = true">证书类型：{{phoneSelectCertifyName}}<i class="el-icon-caret-bottom"></i></div>
        </div>
        <v-refresh :on-refresh="onRefresh">
            <v-reload :on-infinite-load="onInfiniteLoad" :parent-pull-up-state="infiniteLoadData.pullUpState">
                <div v-for="(item,index) in phBookData" :key="index" class="ph-book-child-con clearfix" @click="getTeaching(item.Id)">
                    <div class="fl text-book-img-con">
                        <img :src="item.BookCover" />
                    </div>
                    <div class="fr text-book-info-con">
                        <h4 class="u-label-con">{{item.Title}}</h4>
                        <p class="u-label-con">
                            <span>作者：</span>
                            <span>{{item.Author}}</span>
                        </p>
                        <p class="u-label-con">
                            <span>出版时间：</span>
                            <span>{{item.IssueDate}}</span>
                        </p>
                        <p class="u-label-con">
                            <span style="margin-right:">ISBN：</span>
                            <span>{{item.ISBN}}</span>
                        </p>
                        <p class="u-label-con">图书简介：</p>
                        <p class="p-book-intro-con">{{item.TextBookBrief}}</p>
                    </div>
                </div>
            </v-reload>
        </v-refresh>
    </div>
    <!-- 登录弹框 -->
    <newLogin :isShow="showObject"></newLogin>
    <!-- 移动端选择时间 -->
    <van-action-sheet v-model="showPhoneYear">
        <div class="ph-select-year-con">
            <div class="p-year-li van-hairline--bottom" @click="getFullYear">全部</div>
            <ul>
                <li class="p-year-li van-hairline--bottom" v-for="(item,index) in timeList" :key="index" @click="getYear(index,item)">{{item}}年</li>
            </ul>
            <div class="p-year-li van-hairline--bottom" @click="getEndYear">{{endYear}}年以前</div>
        </div>
    </van-action-sheet>
    <!-- 移动端选择证书类型 -->
    <van-action-sheet v-model="showPhoneCerfity">
        <div class="ph-select-year-con">
            <div class="p-year-li van-hairline--bottom" v-for="item in certifycateList" :key="item.id" @click="changeCerfityType(item.id)">{{item.CertificateName}}</div>
        </div>
    </van-action-sheet>
</div>
</template>

<script>
import downFresh from "components/refreshData/downFresh.vue";
import pullUpReload from "components/refreshData/pullUpReload.vue";
import newLogin from "components/videoLogin.vue";
export default {
    data() {
        return {
            imgs: 'https://file.clpp.org.cn/ykt/ori/dd6xaesrd5lfbwst9cqswg/AQcWHT6ENFCpTGMQ.png',
            isTab: 1,
            pageSize: 10,
            type: 1,
            totalCount: 0,
            currentPage4: 1,
            newsList: [],
            phDetailsData: [],
            infiniteLoadData: {
                initialShowNum: 3, // 初始显示多少条
                everyLoadingNum: 3, // 每次加载的个数
                pullUpState: 0, // 子组件的pullUpState状态
                pullUpList: [], // 上拉加载更多数据的数组
                showPullUpListLength: this.initialShowNum // 上拉加载后所展示的个数
            },
            index: "clppx",
            year: "",
            isBefor: "0",
            phBookData: [],
            booksInfoList: [],
            timeList: [],
            endYear: "",
            yearShowActive: true,
            endYearShowActive: false,
            yearIndexShowActive: -1,
            showObject: {
                isShow: false
            },
            videoTypeList: [],
            certifycateList: [],
            certifycateId: '',
            yearOptions: [],
            yearValue: '',
            showPhoneYear: false,
            phoneSelectYear: '全部',
            showPhoneCerfity: false,
            phoneSelectCertifyName: ''
        };
    },
    components: {
        "v-refresh": downFresh,
        "v-reload": pullUpReload,
        newLogin
    },
    created() {
        this.getCerfitycateList();
        this.getCurrentYear();
    },
    computed: {
        association: function () {
            return this.$store.state.association;
        },
        userInfo() {
            return this.$store.state.auth;
        }
    },
    methods: {
        changeCerfityType(id) {
            this.certifycateId = id;
            this.showPhoneCerfity = false;
            this.certifycateList.forEach(val => {
                if (val.id == this.certifycateId) {
                    this.phoneSelectCertifyName = val.CertificateName;
                }
            });
            this.getTextBookList();
        },
        getCerfitycateList() {
            this.$http.post("/api/XOrg/AssociationIndex/getCertificateList").then(res => {
                if (res.code > 0) {
                    this.certifycateList = res.list;
                    if (this.certifycateList.length > 0) {
                        const [{
                            CertificateName,
                            id
                        }] = this.certifycateList;
                        this.certifycateId = id;
                        this.phoneSelectCertifyName = CertificateName;
                        this.getTextBookList();
                        this.getVideoTypeAllList();
                    }
                }
            });
        },
        getVideoTypeAllList() {
            var that = this;
            that.$http
                .post("/api/XOrg/VideoType/getVideoTypeAllList", {})
                .then(rst => {
                    if (rst.code > 0) {
                        that.videoTypeList = rst.list;
                    } else {
                        that.$message.warning(rst.msg);
                    }
                });
        },
        toVideoList(type) {
            this.$router.push({
                name: "videoChart",
                params: {
                    videoType: type
                }
            });
        },
        getCurrentYear() {
            let newDate = new Date();
            let currentYear = newDate.getFullYear();
            for (let i = 0; i < 8; i++) {
                this.timeList.push(currentYear - i);
            }
            this.endYear = this.timeList[this.timeList.length - 1];
        },
        onRefresh(done) {
            this.phDetailsData = [];
            this.getTextBookList();
            done();
        },
        onInfiniteLoad(done) {
            this.getTextBookList();
            done();
        },
        handleSizeChange(val) {
            this.pageSize = val;
            this.currentPage4 = 1;
            this.getTextBookList(1);
        },
        handleCurrentChange(val) {
            this.currentPage4 = val;
            this.getTextBookList(val);
        },
        goHome() {
            this.$router.push({
                name: "xHome"
            });
        },
        getTeaching(id) {
            this.$router.push({
                name: 'teachingDetails',
                params: {
                    bookId: id
                }
            });
        },
        getTextBookList() {
            this.$http
                .post("/api/XOrg/TextBook/getTextBookList", {
                    index: this.index,
                    certificateId: this.certifycateId,
                    IssueDate: this.year,
                    textBookName: this.textBookName,
                    isBefor: this.isBefor,
                    page: this.currentPage4,
                    pageSize: this.pageSize
                })
                .then(rst => {
                    if (rst.code > 0) {
                        this.booksInfoList = rst.list;
                        this.currentPage4 = rst.pagination.pageIndex;
                        this.totalCount = rst.pagination.totalCount;
                        this.phBookData = rst.list;
                        if (this.phBookData.length == this.total) {
                            this.infiniteLoadData.pullUpState = 3;
                        } else if (this.phBookData.length < this.total) {
                            this.infiniteLoadData.pullUpState = 2;
                        } else {
                            this.infiniteLoadData.pullUpState = 1;
                        }
                        this.canael();
                    } else {
                        this.$message.warning(rst.msg);
                    }
                });
        },
        canael() {
            this.isBefor = "0";
            this.year = "";
        },
        // 全部年份
        getFullYear() {
            this.phoneSelectYear = '全部';
            this.showPhoneYear = false;
            this.yearShowActive = true;
            this.endYearShowActive = false;
            this.yearIndexShowActive = -1;
            this.getTextBookList();
        },
        // 选择其他年份
        getYear(index, time) {
            this.phoneSelectYear = time;
            this.showPhoneYear = false;
            this.isBefor = "0";
            this.year = time + "-" + "01" + "-" + "01";
            this.yearShowActive = false;
            this.endYearShowActive = false;
            this.yearIndexShowActive = index;
            this.getTextBookList();
        },
        // 获取末尾年份之前
        getEndYear() {
            this.phoneSelectYear = this.endYear;
            this.showPhoneYear = false;
            this.endYearShowActive = true;
            this.yearShowActive = false;
            this.yearIndexShowActive = -1;
            this.year = this.endYear + "-" + "01" + "-" + "01";
            this.isBefor = "1";
            this.getTextBookList();
        }
    }
};
</script>

<style lang="scss">
.wl-n-metarial-wrapper {
    .new-center-content {
        margin: 40px auto 0;
        width: 1200px;
        min-height: 600px;
    }

    .new-top-nav {
        width: 220px;
        height: 78px;
        padding: 21px 0px;
        background: #2d82ff;

        .new-top-title {
            font-size: 58px;
            font-family: MicrosoftYaHei;
            font-weight: 400;
            color: #0155d1;
            margin-left: 23px;
            width: 48px;
        }

        .new-top-navtitle {
            padding-top: 16px;
            font-size: 18px;
            color: #fff;
        }

        .new-top-ews {
            padding-top: 8px;
            font-size: 14px;
            color: #0155d1;
            font-weight: bold;
        }
    }

    .new-center-tab {
        width: 220px;

        .new-center-dynamic {
            margin-top: 20px;
            font-size: 16px;
            height: 38px;
            background: #e9ebf0;
            line-height: 40px;
            cursor: pointer;

            padding: 0px 16px 0px 20px;
        }

        .link-child-li {
            color: black;
        }

        .class-back {
            background: #2d82ff;
            color: #fff;
        }

        .c-video-change-btn {
            margin-top: 0;
            border-top: 1px solid #fff;
        }

        .wl-icon-xiangyou {
            height: 100%;
        }
    }

    .left-main-content {
        width: 950px;

        .new-center-listnav {
            margin-bottom: 30px;
            border-bottom: 2px solid #e9ebf0;
            height: 38px;
            line-height: 38px;

            h2 {
                font-size: 16px;
                font-family: MicrosoftYaHei;
                font-weight: 400;
                width: 80px;
                height: 100%;
                border-bottom: 2px solid #2d82ff;
                float: left;
            }

            .new-center-path {
                float: right;

                .wl-icon-zhuye1 {
                    color: #a4a4a4;
                    font-size: 16px;
                }

                span {
                    margin-left: 7px;
                    font-size: 14px;
                    cursor: pointer;
                }
            }
        }

        .metarial-list-con {
            .choose-publishBooks-time {
                padding: 10px 15px;
                border: 1px solid #e9ebf0;
            }

            .certificate-type-change-con {
                border-top: none;
            }

            .change-year-btn {
                margin-right: 15px;
                padding: 7px 8px;
                border-radius: 2px;
                cursor: pointer;
            }

            .yearActive {
                background: #2d82ff;
                color: #fff;
            }

            .change-label {
                font-weight: bold;
            }
        }

        .meta-list-main {
            margin-bottom: 20px;
            padding-bottom: 20px;
            border: 1px solid #e9ebf0;
        }

        .metarial-list-ul-con {
            border-top: none;
        }

        .metarial-list-li {
            margin-top: 27px;
            width: 450px;
            cursor: pointer;
            height: 236px;
            padding: 15px 10px;
            box-sizing: border-box;
            cursor: pointer;

            a {
                display: block;
                color: #666;
            }
        }

        .metarial-list-li:hover {
            background: #e9ecf0;
        }

        .metarial-list-li:nth-child(odd) {
            margin: 27px 30px 0 15px;
        }

        .publishBooks-list-img {
            padding: 10px 5px;
            width: 120px;
            height: 180px;
            overflow: hidden;
            border: 1px solid #dfe2e6;
            background: #fff;
            box-sizing: border-box;
        }

        .publishBooks-list-info {
            width: 286px;

            .info-books-name {
                margin-top: 4px;
                color: #333;
                font-size: 16px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }

            .info-books-author {
                margin-top: 10px;
                color: #666;
                font-size: 14px;
            }

            .info-books-introduce {
                margin-top: 10px;
                line-height: 1.5;
                max-height: 65px;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 3;
                overflow: hidden;
            }
        }
    }

    .ph-new-center-content {
        display: none;

        .crumbs-text {
            background: #f5f7fb;
            height: 40px;
            line-height: 40px;
            color: #666;

            span {
                margin: 0 3px;
            }
        }

        .new-center-navigation {
            height: 32px;
            line-height: 32px;
            margin-top: 10px;
            padding: 0px 20px;

            h2 {
                background: #e6e6e6;
                width: 90px;
                font-size: 14px;
                font-weight: normal;
                text-align: center;
                float: left;
            }

            .activa {
                background: #2d82ff;
                color: #fff;
            }
        }

        .ph-book-child-con {
            margin-bottom: 15px;
            padding: 10px 20px;
            background: #fff;

            .text-book-img-con {
                width: 100px;
                height: 153px;

                img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                }
            }

            .text-book-info-con {
                width: calc(100% - 110px);
                font-size: 14px;
            }

            .p-book-intro-con {
                text-indent: 2em;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                height: 33px;
                color: #333;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 2;
                font-size: 12px;
            }

            .u-label-con {
                margin-bottom: 5px;
            }
        }
    }

    .ph-select-year-con {
        text-align: center;

        .p-year-li {
            height: 40px;
            line-height: 40px;
        }
    }
}

@media screen and (max-width: 980px) {
    .wl-n-metarial-wrapper {
        background: #fff;

        .new-center-content {
            display: none;
        }

        .ph-new-center-content {
            display: block;

            .ph-select-year-btn {
                padding-left: 20px;
                height: 36px;
                line-height: 36px;
            }
        }
    }
}
</style>
